import type { Theme } from "@mui/material";
import {
	DANGER_MYPLANN_DARK,
	DANGER_MYPLANN_LIGHT,
	SUCCESS_MYPLANN_DARK,
	SUCCESS_MYPLANN_LIGHT,
} from "web_myplann/Utils/constants";

export const getBalanceColor = (balance: number, theme: Theme) => {
	const isDark = theme.palette.mode === "dark";

	if (balance > 0) {
		return isDark ? SUCCESS_MYPLANN_DARK : SUCCESS_MYPLANN_LIGHT;
	}

	return isDark ? DANGER_MYPLANN_DARK : DANGER_MYPLANN_LIGHT;
};
